module.exports = __webpack_public_path__ + "static/media/moriartygroup.723e35bb.png";